export const selectLabelBatchStatusModalBatches = (state) => state.batches || [];
export const selectFillMethodByBatchId = (state, props) => {
  const { batchId } = props;
  return state?.batches?.find((batch) => batch.batchId === batchId)?.fillMethod;
};
export const selectStatusByBatchId = (state, props) => {
  const { batchId } = props;
  const batches = state.batches || [];
  const selectedBatch = batches.find((batch) => batch.batchId === batchId) || {};
  return selectedBatch?.statusId;
};
export const selectWarnOrErrorByBatchId = (state, props) => {
  const { batchId } = props;
  const warnOrErrors = state.errorsAndWarnings || [];
  return warnOrErrors.find((err) => err.batchId === batchId);
};
